<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
  <span class="icon"><i class="fas fa-pallet"></i></span>{{ 'AsnInfo.Header.AsnInfoSearchComponentHeader' | translate }}</h1>
  <p-card class="mx-2">
    <p-accordion [multiple]="true">
      <p-accordionTab
        header="{{ 'AsnInfo.Header.SearchFormHeader' | translate }}"
        [(selected)]="isSearchFormOpen"
      >
        <ng-content *ngTemplateOutlet="settingSearchFormTemplate"></ng-content>
      </p-accordionTab>
      <p-accordionTab
        header="{{ 'AsnInfo.Header.HeaderTable' | translate }}"
        [(selected)]="isHeaderTableOpen"
      >
        <ng-content *ngTemplateOutlet="settingHeaderTemplate"></ng-content>
      </p-accordionTab>
    </p-accordion>
  </p-card>


  <ng-template #settingSearchFormTemplate>
    <form [formGroup]="searchFormGroup">
      <div class="p-fluid formgrid grid">
        <div class="field col-3">
          <p class="mt-0 mb-2"><span class="requiredStart">*</span>{{ 'AsnInfo.SearchForm.HubPlantId' | translate }}</p>
          <laas-plant-dropdown
            [isSingle]="true"
            formControlName="plant">
          </laas-plant-dropdown>
        </div>
        <div class="field col-3">
          <label><span class="requiredStart">*</span>{{ 'AsnInfo.SearchForm.Facility' | translate }}</label>
          <div class="item">
            <laas-facility-dropdown 
              [isSingle]="true" 
              formControlName="facility">
            </laas-facility-dropdown>
          </div>
        </div>
        <div class="field col-3">
          <p class="mt-0 mb-2"><span class="requiredStart">*</span>{{'AsnInfo.SearchForm.Storer' | translate }}</p>
          <p-dropdown formControlName="storer"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
          [options]="storerMappingOptions" appendTo="body"></p-dropdown>
        </div>
        <div class="field col-3">
          <label>{{ 'AsnInfo.SearchForm.AsnNo' | translate }}</label>
          <p-chips formControlName="mo" separator="," (onAdd)="chipsAdd($event, 'mo')"></p-chips>
        </div>
        <div class="field col-3">
          <label>{{ 'AsnInfo.SearchForm.SKU' | translate }}</label>
          <input type="text" pInputText formControlName="sku"/>
        </div>
        <div class="field col-12">
          <small>
            <strong class="p-invalid">
              {{ 'StockInfoSearchComponent.Message.SearchFormNotification' | translate }}
            </strong>
          </small>
        </div>
      </div>
      <div>
        <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick()">
        </button>
        <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" type="reset" (click)="resetBtnClick()"
        class="p-button-secondary ml-2"></button>
      </div>
    </form>
  </ng-template>


  <ng-template #settingHeaderTemplate>
    <div class="mt-2">
      <laas-data-table
        #headerTable
        [value]="searchResults"
        [defaultColumns]="columns"
        [loading]="isLoading"
        [tableKey]="preferenceKey"
        [paginator]="false">
        <ng-template pTemplate="caption">
          <ng-container *ngTemplateOutlet="calculateRegion"></ng-container>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'orderDocStatus'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: doStatusOptions | replaceNullWith:'-' }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'externMoveOrderKey'">
                <div class="overflow-text">
                  <a href="javascript: void(0);" (click)="gotoProgress($event, rowData.externMoveOrderKey)">{{rowData[col.field]}}</a>
                </div>
              </ng-container>

              <ng-container *ngSwitchDefault>
                <ng-container [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    <div class="overflow-text">{{ rowData[col.field] | date: "yyyy-MM-dd HH:mm" | replaceNullWith:'-'}}</div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </laas-data-table>
    </div>
  </ng-template>



  <ng-template #calculateRegion>
    <div class="col-12 p-text-bold"
         style="display: block; padding: 10px 0; line-height: 1.6; white-space: normal !important; word-break: break-all;">
      {{totalResult}}
    </div>
  </ng-template>
</div>

<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
